import {
  ActionsCol,
  DeadlineCol,
  PartTypeCol,
  PriceCol,
  ReasonCol,
  ReceivedCol,
  SupplierCol,
  SupplierPartCol
} from '@/main/screens/order/reassignOrder/components/stylesColumns';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';

interface IHeaderReassignItem {
  showPrices?: boolean;
}

export default function HeaderReassignItem({
  showPrices = true
}: Readonly<IHeaderReassignItem>) {
  return (
    <S.ProductsListHead>
      <ReceivedCol>
        {getTranslateByKey('information.receivedPartDescription')}
      </ReceivedCol>
      <SupplierPartCol>
        {getTranslateByKey('information.supplierPartDescription')}
      </SupplierPartCol>
      <SupplierCol>{getTranslateByKey('companyType.supplier')}</SupplierCol>
      <PartTypeCol>{getTranslateByKey('information.partTypes')}</PartTypeCol>
      <DeadlineCol>
        {getTranslateByKey('information.deliveryDeadline')}
      </DeadlineCol>
      {showPrices && (
        <PriceCol>{getTranslateByKey('information.price')}</PriceCol>
      )}
      <ReasonCol>{getTranslateByKey('information.reason')}</ReasonCol>
      <ActionsCol />
    </S.ProductsListHead>
  );
}
